// The timezone control shown in the slot picker. Defaults to the visitor's
// auto-detected zone (Intl) and lets them change it; the picker re-renders all
// slot times in the chosen zone. Implements: architecture.md v1.0 (tz display).

import type { JSX } from 'react';
import { commonTimeZones, zoneLabel } from '../lib/time.js';

export function TimeZoneSelect({
  value,
  onChange,
}: {
  value: string;
  onChange: (tz: string) => void;
}): JSX.Element {
  const zones = commonTimeZones(value);
  return (
    <div className="tz-control">
      <span aria-hidden="true" style={{ color: 'var(--muted)' }}>
        🌐
      </span>
      <label htmlFor="tz-select">Times in</label>
      <select
        id="tz-select"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        aria-label="Display timezone"
      >
        {zones.map((tz) => (
          <option key={tz} value={tz}>
            {zoneLabel(tz)}
          </option>
        ))}
      </select>
    </div>
  );
}
